export default "assets/images/icons/entity-color-15ef96ca.svg";